import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ReplyAllIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "ReplyAll",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M10.12 24.08c-.48 0-.92-.19-1.23-.51l-6.4-6.4c-.32-.32-.51-.76-.51-1.24s.2-.92.51-1.24L8.9 8.33c.32-.32.76-.51 1.24-.51.97 0 1.75.78 1.75 1.75 0 .48-.2.92-.51 1.24l-5.17 5.12 5.16 5.16c.32.32.52.76.52 1.25 0 .97-.78 1.75-1.75 1.75h-.02Zm12.63-6.44c2.15 0 3.89 1.74 3.89 3.89v1.11a1.677 1.677 0 0 0 3.34.01v-1.12a7.23 7.23 0 0 0-7.22-7.2h-6.21l3.54-3.54a1.746 1.746 0 0 0-1.34-2.87c-.43 0-.82.16-1.13.41s-6.4 6.4-6.4 6.4c-.31.32-.51.75-.51 1.23V16c0 .45.18.87.48 1.17l6.39 6.41c.32.32.76.51 1.24.51.97 0 1.75-.78 1.75-1.75 0-.48-.2-.92-.51-1.24l-3.45-3.45h6.15Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M29.43 27.71c-.63 0-1.14-.51-1.14-1.14v-5.71c0-3.15-2.56-5.71-5.71-5.71H10.01a1.14 1.14 0 1 1 0-2.28h12.57c4.41 0 8 3.59 8 8v5.71c0 .63-.51 1.14-1.14 1.14Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M18 23.14c-.29 0-.58-.11-.81-.33l-8-8a1.14 1.14 0 0 1 0-1.62l8-8a1.14 1.14 0 0 1 1.62 0c.45.45.45 1.17 0 1.62L11.62 14l7.19 7.19a1.14 1.14 0 0 1-.81 1.95"
      }), /*#__PURE__*/_jsx("path", {
        d: "M10 23.14c-.29 0-.58-.11-.81-.33l-8-8a1.14 1.14 0 0 1 0-1.62l8-8a1.14 1.14 0 0 1 1.62 0c.45.45.45 1.17 0 1.62L3.62 14l7.19 7.19a1.14 1.14 0 0 1-.81 1.95"
      })]
    })
  }));
};